module.exports = __webpack_public_path__ + "static/media/How to create Invoice without tax.1cb86034.png";